import React from 'react';
import BaseFeaturesList from './BaseFeaturesList';
import features from './kuper.json';

const KuperFeatures = () => (
  <BaseFeaturesList features={features}/>
);

export default KuperFeatures;
